//  延迟需要为0, 不然页面连接会出现中断情况
import { write_style } from "utils/util";

let animateDelay = 600;
let animateDuration = 600;
let scrollTop = 0;
function before_enter(el) {
  scrollTop = $(window).scrollTop();
  $(el).css({
    zIndex: 1,
    opacity: 1,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  });
  $.Velocity.hook(el, "translateY", $(window).height());
  $(window).scrollTop(0);

  write_style(
    "scrollNext",
    `html,body {max-height: 100vh;overflow: hidden;height:100vh;}`
  );
}

function enter(el, done) {
  $(window).one("scroll-next-animate-start", () => {
    $(el)
      .velocity("stop")
      .velocity(
        {
          translateY: 0,
        },
        {
          duration: animateDuration,
          display: $(el).css("display"),
          complete: done,
          easing: "linear",
        }
      );
  });
}

function after_enter(el) {
  el.removeAttribute("style");
}

function before_leave(el) {
  $(el).css({
    opacity: 1,
    zIndex: 2,
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    marginTop: scrollTop * -1,
  });
  $.Velocity.hook(el, "translateY", 0);
}

function leave(el, done) {
  setTimeout(() => {
    $(el)
      .velocity("stop")
      .velocity(
        {
          translateY: $(window).height() * -1,
        },
        {
          duration: animateDuration,
          easing: "linear",
          begin: () => {
            $(window).trigger("scroll-next-animate-start");
          },
          complete: () => {
            done();
            $(el).remove();
            write_style("scrollNext", ``);
          },
        }
      );
  }, animateDelay);
}

function after_leave(el) {}

export default {
  before_enter,
  enter,
  after_enter,
  before_leave,
  leave,
  after_leave,
};
